import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	avatarPickerGenericError: {
		id: 'admin-pages-priorities.controllers.avatar-picker.avatar-picker-generic-error',
		defaultMessage: 'Something went wrong. Please try again.',
		description: 'generic error shown when there is an error fetching avatars',
	},
});
